module.exports = __webpack_public_path__ + "static/bf-logo-0d024a768a75a5fae8cd1bbfa6b054bd.png";